// extracted by mini-css-extract-plugin
export default {"socials":"styles_socials__lW5No","social":"styles_social__5ISJr"};